class @App.Clubs.ClubsResourcesView
  constructor: ->
    @bindElements()

  bindElements: =>
    $(document).on 'change', '[data-action="updateResourcesApplication"]', (e) ->
      input = $(this)
      window.location.href = '/student_talks/resources/?application_id='+ input.val()
    scrollToPromo()
    BetterModals.showModal($('#modalRenewNotice')) if $('#modalRenewNotice').length

  scrollToPromo = ->
    return if window.location.hash != 'share-clubs'
    document.getElementById('share-clubs').scrollIntoView();

    return

$(document).on 'turbo:load', ->
  new App.Clubs.ClubsResourcesView() if $('.clubsResourcesView').length
